<template>
	<div class="shadow_bg" id="edu_threeClass_dialog">
		<div class="windows_table">
			<div class="close_btn" @click="close_window"><img src="../../assets/img/close_icon.png"></div>
			<!-- 学校开始 -->
			<div class="school_block">
				<div class="campus_safetit"><img src="../../assets/img/school_icon.png">选择学校</div>
				<ul>
					<li :class="activeClass == index ? 'on' : ''" v-for="(org, index) in orgList" :key="index" @click="changeOrg(index, org.orgId)">{{ org.orgName }}</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
export default {
	data() {
		return {
			orgList: [],
			activeClass: 0
		}
	},
	methods: {
		close_window() {
			this.$emit("closeTable");
		},
		initData(index) {
			let _this = this;
			_this.activeClass = index;
			this.$http.get("/dataView/threeClass/getOrgListByRoom?orgCode=" + orgCode).then(res => {
				if (res.data.code === 200) {
					var result = res.data.result;
					if (result.length > 0) {
						_this.orgList = result;
					}
				}
			});
		},
		//切换学校
		changeOrg(index, orgId) {
			this.activeClass = index;
			this.$emit("changeOrg2",index,orgId);
		}
	}
}
</script>
<style scoped lang="scss">
	#edu_threeClass_dialog {
		width: 100%;
		height: 100%;
		position: fixed;
		background: rgba(0, 0, 0, 0.6);
		padding: 0 !important;
		top: 0;
		left: 0;
		z-index: 999;

		.windows_table {
			width: 800px;
			height: 500px;
			position: fixed;
			padding-top: 0.1rem;
			top: 300px;
			left: 50%;
			margin-Left: -400px;
			z-index: 9999;
			background-image: linear-gradient(135deg, #16474d, #051216);
			border-radius: 0.1rem;
			border: 1px solid #006e74;
			box-shadow: 0 0 0.2rem #00f3ff;
		}
	
		.close_btn {
			position: absolute;
			width: 0.4rem;
			right: 0.2rem;
			top: 0.2rem
		}
	
		.close_btn img {
			width: 100%;
		}
	
		.close_btn:hover {
			cursor: pointer;
		}
	
		//下方区域的布局
		.campus_safetit {
			width:100%;
			font-size: 0.25rem;
			color: #55ffff;
			margin-bottom: 0.1rem;
			padding: 0 0 0.2rem 0;
			border-bottom: 1px solid #006264;
		}
		.campus_safetit img {
			width: 0.3rem;
			margin-right: 0.05rem;
			vertical-align: middle;
		}
	
		.school_block {
			width:100%;
			padding: 0.3rem;
		}
	
		.school_block ul {
			white-space: wrap;
			height: 400px;
			overflow-y: auto;
		}
	
		.school_block ul li {
			width: fit-content;
			max-width: 4rem;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			padding: 0.1rem 0.2rem;
			color: #00dad3;
			font-size: 0.2rem;
			border-radius: 2rem;
			margin: 0.2rem 0.2rem 0 0;
			box-shadow: 0px 0px 5px #36a3a3 inset;
			display: inline-block;
		}
	
		.school_block ul li:hover,
		.school_block ul li.on {
			background-image: linear-gradient(to right, rgba(0, 244, 224, 0.8), rgba(1, 192, 244, 0.7));
			color: #002a2a;
			cursor: pointer;
		}
	
		.school_block ul::-webkit-scrollbar {
			width: 3px;
			height: 3px;
		}
	
		.school_block ul::-webkit-scrollbar-thumb {
			border-radius: 30%;
			background: linear-gradient(to right, rgba(16, 221, 191, 0.6), rgba(27, 118, 103, 0.6), rgba(20, 195, 221, 0.6));
		}
	
		.school_block ul::-webkit-scrollbar-track {
			border-radius: 30%;
			background: linear-gradient(to right, rgba(20, 195, 221, 0), rgba(11, 252, 252, 0.31), rgba(20, 195, 221, 0));
		}
	}
</style>